(ns renolit-roofing-service.util.geometry
  (:require ["@turf/boolean-point-in-polygon" :refer [booleanPointInPolygon]]
            ["@turf/boolean-within" :refer [booleanWithin]]
            ["@turf/helpers" :as turf]))

(defn point
  [lng-lat]
  (turf/point (clj->js lng-lat)))

(defn polygon
  [path]
  (turf/polygon #js [(clj->js (conj path (first path)))]))

(defn point-in-polygon?
  [point polygon]
  (booleanPointInPolygon point polygon))

(defn polygon-within-polygon?
  [polygon polygon']
  (booleanWithin polygon polygon'))

(defn- clamp
  [v lo hi]
  (max lo (min v hi)))

(defn- bounds-rect
  [poly]
  (let [lngs (map first poly)
        lats (map second poly)
        min-lng (apply min lngs)
        max-lng (apply max lngs)
        min-lat (apply min lats)
        max-lat (apply max lats)]
    {:min-lng min-lng
     :max-lng max-lng
     :min-lat min-lat
     :max-lat max-lat
     :w (- max-lng min-lng)
     :h (- max-lat min-lat)}))

(defn- rect-around
  [{:keys [lng lat]} half-w half-h]
  [[(- lng half-w) (- lat half-h)]
   [(- lng half-w) (+ lat half-h)]
   [(+ lng half-w) (+ lat half-h)]
   [(+ lng half-w) (- lat half-h)]])

(defn rect-in-rect
  ([parent-poly click] (rect-in-rect parent-poly click 0.6 1.0e-9))
  ([parent-poly {:keys [lng lat]} scale epsilon]
   (let [{:keys [min-lng max-lng min-lat max-lat w h]}
         (bounds-rect parent-poly)

         desired-half-w (* 0.5 w scale)
         desired-half-h (* 0.5 h scale)

         max-half-w (max 0.0 (- (* 0.5 w) epsilon))
         max-half-h (max 0.0 (- (* 0.5 h) epsilon))

         half-w (min desired-half-w max-half-w)
         half-h (min desired-half-h max-half-h)

         min-center-lng (+ min-lng half-w epsilon)
         max-center-lng (- max-lng half-w epsilon)
         min-center-lat (+ min-lat half-h epsilon)
         max-center-lat (- max-lat half-h epsilon)

         center-lng (if (<= min-center-lng max-center-lng)
                      (clamp lng min-center-lng max-center-lng)
                      (/ (+ min-lng max-lng) 2.0))
         center-lat (if (<= min-center-lat max-center-lat)
                      (clamp lat min-center-lat max-center-lat)
                      (/ (+ min-lat max-lat) 2.0))]
     (rect-around {:lng center-lng
                   :lat center-lat} half-w half-h))))

(defn zone-polygon
  ([{:keys [width height]} {:keys [lat lng]}]
   (let [half (* 0.1 (min width height))]
     (rect-around {:lng lng :lat lat} half half)))
  ([parent-polygon center scale]
   (rect-in-rect parent-polygon center scale 1.0e-9)))

(defn- translate-point
  [[lng lat] [dlng dlat]]
  [(+ lng dlng) (+ lat dlat)])

(defn- translate-polygon
  [poly delta]
  (mapv #(translate-point % delta) poly))

(defn- delta-from-first-point
  [old-polygon new-polygon]
  (let [[olng olat] (first old-polygon)
        [nlng nlat] (first new-polygon)]
    [(- nlng olng) (- nlat olat)]))

(defn restriction-from-center
  [{:keys [lat lng]} {:keys [delta-lat delta-lng]}]
  (let [lat-rad (* lat (/ js/Math.PI 180.0))
        cos-lat (max 1.0e-6 (js/Math.cos lat-rad))
        delta-lng' (or delta-lng (/ delta-lat cos-lat))]
    {:north (+ lat delta-lat)
     :south (- lat delta-lat)
     :east  (+ lng delta-lng')
     :west  (- lng delta-lng')}))

(defn polygon-center
  [poly]
  (let [n (max 1 (count poly))]
    [(/ (reduce + (map first poly)) n)
     (/ (reduce + (map second poly)) n)]))

(defn- zone-center-inside?
  [parent-poly child-poly]
  (let [[lng lat] (polygon-center child-poly)]
    (point-in-polygon?
     (point [lng lat])
     (polygon parent-poly))))

(defn snap-child-into-parent
  [parent-poly child-poly]
  (let [{:keys [min-lng max-lng min-lat max-lat]} (bounds-rect parent-poly)
        {:keys [w h]} (bounds-rect child-poly)
        [clng clat] (polygon-center child-poly)
        half-w (* 0.5 w)
        half-h (* 0.5 h)
        snapped-lng (clamp clng (+ min-lng half-w) (- max-lng half-w))
        snapped-lat (clamp clat (+ min-lat half-h) (- max-lat half-h))
        dlng (- snapped-lng clng)
        dlat (- snapped-lat clat)]
    (if (and (zero? dlng) (zero? dlat))
      child-poly
      (translate-polygon child-poly [dlng dlat]))))
